import { themeService } from '../../../../services/theme/ThemeService';

export async function loader(callback) {
  if (themeService.includeTheme(themeService.THEMES.THEME_TO_BUILD_A_PROFILE_REPORTS)) {
    await import(/* webpackChunkName: "2bap1-reports-theme" */ '2bap1-reports/index.less');
  }
  const moduleLayout = await import(/* webpackChunkName: "2bap1-module-layout" */ './layouts/emptyLayout');
  callback(null, moduleLayout.default);
}
